export default function buildTemplateImage(slug, imagePrefix, preview = false) {
  if (preview) {
    return `${process.env.TEMPLATES_BUCKET_URL}/${slug}/${imagePrefix}-preview-1.png`;
  }

  return `${process.env.TEMPLATES_BUCKET_URL}/${slug}/${imagePrefix}-thumb-1.png`;
}
